import { QuestionForm } from './QuestionForm';

export default QuestionForm;